
import { Component, Vue, Prop } from 'vue-property-decorator'
import KatexText from '@/components/atoms/KatexText.vue'

/**
 * 設問解答の表示欄(数式)
 */
@Component({
  components: {
    KatexText,
  },
})
export default class AnswerFormula extends Vue {
  /** latex形式文字列 */
  @Prop()
  private src!: string

  /**
   * 表示文字列が空の際に前後テキストとの縦位置がズレるため、対処用のgetterメソッド
   *
   * @returns 出力するlatex文字列
   */
  private get outputSrc(): string {
    // 空文字列の場合は全角スペースを返す
    if (this.src === '') {
      return '　'
    }
    return this.src
  }
}
